var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.onClose}},[_vm._t("dialogBody")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }